// BuscarClienteModal.js (Actualizado)

import React, { useState, useEffect, useRef } from 'react';
import './BuscarClienteModal.css';
import PuenteApi from '../../../../pageauth/PuenteApi';
import Mensaje from '../../../../Mensaje';
import Swal from 'sweetalert2';

const HEADER_HEIGHT = 30;

const BuscarClienteModal = ({ isVisible, onClose, onSelectcliente, tipoComanda }) => {

    const { SetMensaje } = Mensaje();
    const { ObtenerClientes, EliminarCliente, ObtenerClientesRemito } = PuenteApi();

    const [clientesLista, setClientesLista] = useState([
        { razon_social: 'Cargando clientes...', cuit: '', condicion_iva: 'Cargando', domicilio: 'Cargando', letra_factura: '-', id: 0 },
    ]);

    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('RAZON SOCIAL');
    const [filteredClientes, setFilteredClientes] = useState(clientesLista);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const searchInputRef = useRef(null);

    const formatCuit = (cuit) => {
        // Verifica si el CUIT ya está formateado
        if (/^\d{2}-\d{8}-\d{1}$/.test(cuit)) {
            return cuit; // Si ya está formateado, lo retorna tal cual
        }

        // Asegura que el CUIT tenga 11 dígitos y formatea con guiones
        const cuitStr = cuit.toString().padStart(11, '0');  // Asegura que el CUIT tenga 11 dígitos
        return `${cuitStr.slice(0, 2)}-${cuitStr.slice(2, 10)}-${cuitStr.slice(10, 11)}`;
    };

    useEffect(() => {
        const lowerCaseSearch = searchTerm.toLowerCase();

        const results = clientesLista.filter(p => {
            if (filterType === 'RAZON SOCIAL') {
                return p.razon_social.toLowerCase().includes(lowerCaseSearch);
            } else if (filterType === 'CUIT') {
                return p.cuit.toLowerCase().includes(lowerCaseSearch);
            }
            return false;
        });

        setFilteredClientes(results);
        setSelectedIndex(0);
    }, [searchTerm, filterType]);

    useEffect(() => {
        if (isVisible && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isVisible]);


    const handleSelect = (cliente) => {
        const clienteParaFactura = {
            id: cliente.id,
            nombre: cliente.razon_social,
            cuit: cliente.cuit,
            condicion_iva: cliente.condicion_iva,
            domicilio: cliente.domicilio,
            provincia: cliente.provincia,
            localidad: cliente.localidad,
            cp: cliente.cp,
            letra_factura: cliente.letra_factura,
            cuenta_corriente: cliente.cuenta_corriente,
            credito_maximo: cliente.credito_maximo,
            credito_disponible: cliente.credito_disponible,
            saldo_remitos: cliente.saldo_remitos,
            combustible: cliente.combustible,
            minimercado: cliente.minimercado,
            playa: cliente.playa,
        };
        onSelectcliente(clienteParaFactura);
        onClose();
    };

    const handleConfirm = () => {
        if (filteredClientes.length > 0) {
            handleSelect(filteredClientes[selectedIndex]);
        }
    };

    const tablaRef = useRef(null);
    const scrollInstructionRef = useRef('nearest');

    const handleKeyDown = (event) => {
        event.stopPropagation();
        if (event.key === 'Escape') {
            onClose();
            return;
        }

        if (filteredClientes.length === 0) return;

        // Usamos la forma funcional de setSelectedIndex para obtener el valor más fresco
        setSelectedIndex(prevIndex => {
            let newIndex = prevIndex;

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                scrollInstructionRef.current = 'end'; // Registrar movimiento hacia abajo
                newIndex = Math.min(prevIndex + 1, filteredClientes.length - 1);
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                scrollInstructionRef.current = 'start'; // Registrar movimiento hacia arriba
                newIndex = Math.max(prevIndex - 1, 0);
            } else if (event.key === 'Enter') {
                event.preventDefault();
                handleConfirm();
                return prevIndex;
            }

            return newIndex;
        });
    };

    const handleClick = (index) => {
        scrollInstructionRef.current = 'nearest'; // Un click es neutro o 'nearest'
        setSelectedIndex(index);
    };

    useEffect(() => {
        const container = tablaRef.current;

        if (!container || filteredClientes.length === 0 || !isVisible) return;

        const selectedRow = container.children[selectedIndex];

        if (selectedRow) {

            // 1. Usa scrollIntoView para asegurar que el elemento esté visible
            selectedRow.scrollIntoView({
                behavior: 'smooth',
                block: scrollInstructionRef.current === 'start' ? 'start' : 'nearest', // Al subir, forzamos 'start'
            });

            if (scrollInstructionRef.current === 'start') {
                const newScrollTop = selectedRow.offsetTop - HEADER_HEIGHT;
            }
            scrollInstructionRef.current = 'nearest';
        }

    }, [selectedIndex, isVisible]);

    useEffect(() => {
        if (isVisible) {
            window.addEventListener('keydown', handleKeyDown);
            return () => window.removeEventListener('keydown', handleKeyDown);
        }
    }, [isVisible, filteredClientes.length, handleConfirm, onClose]);


    const obteneClientes2 = async () => {
        try {
            let response = null;
            if (tipoComanda === 'REMITO') {
                response = await ObtenerClientesRemito();
            } else {
                response = await ObtenerClientes();
            }
            if (response && Array.isArray(response) && response.length > 0) {
                const clientes = response.map((cliente) => ({
                    id: cliente.id,
                    razon_social: cliente.razon_social,
                    cuit: cliente.cuit,
                    condicion_iva: cliente.condicion_iva,
                    domicilio: cliente.domicilio,
                    provincia: cliente.provincia,
                    localidad: cliente.localidad,
                    cp: cliente.cp,
                    // letra_factura: cliente.condicion_iva === 'RESPONSABLE INSCRIPTO' ? 'A' : 'B', 
                    letra_factura: 'A',
                    id: cliente.id,
                    cuenta_corriente: cliente.cuenta_corriente,
                    credito_maximo: cliente.credito_maximo,
                    credito_disponible: cliente.credito_disponible,
                    saldo_remitos: cliente.saldo_remitos,
                    combustible: cliente.combustible,
                    minimercado: cliente.minimercado,
                    playa: cliente.playa,
                }));
                setClientesLista(clientes);
                setFilteredClientes(clientes);
            } else {
                SetMensaje("Error", "No se encontraron productos", 3000);
                setClientesLista([{ razon_social: 'Error al cargar clientes...', cuit: '', condicion_iva: 'Cargando', domicilio: 'Cargando', letra_factura: '-', id: 0 }]);
                setFilteredClientes([{ razon_social: 'Error al cargar clientes...', cuit: '', condicion_iva: 'Cargando', domicilio: 'Cargando', letra_factura: '-', id: 0 }]);
            }
        } catch (error) {
            SetMensaje("Error", "Hubo un problema con la solicitud " + error, 3000);
        }
    };

    // Usamos useEffect para obtener los productos al montar el componente
    useEffect(() => {
        if (isVisible) {
            setSearchTerm('');
            obteneClientes2();
            setSelectedIndex(0);
        }
    }, [isVisible]); // Dependencias vacías para que solo se ejecute al montar el componente

    const handleEdit = (cliente) => {
        console.log("Editando cliente:", cliente);
    };

    const handleDelete = async (cliente) => {

        Swal.fire({
            title: "Eliminar Cliente",
            text: `¿Estás seguro de que deseas eliminar el cliente: ${cliente.razon_social}?`,
            icon: "error",
            draggable: true,
            showCancelButton: true,
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'No, cancelar',
            showDenyButton: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const resultado = await EliminarCliente(cliente.id);
                    if (resultado == true) {
                        setClientesLista(clientesLista.filter(c => c.id !== cliente.id));
                        setFilteredClientes(filteredClientes.filter(c => c.id !== cliente.id));
                        Swal.fire({
                            title: "Cliente eliminado correctamente",
                            icon: "success",
                            draggable: true
                        });
                    }

                } catch (error) {
                    SetMensaje("Error", "Hubo un problema al eliminar el cliente.", 3000);
                }
            }
        });
        // const confirmDelete = window.confirm(`¿Estás seguro de que deseas eliminar el cliente: ${cliente.razon_social}?`);

        // if (confirmDelete) {
        //     try {
        //         await PuenteApi().EliminarCliente(cliente.id); 
        //         setClientesLista(clientesLista.filter(c => c.id !== cliente.id));
        //         setFilteredClientes(filteredClientes.filter(c => c.id !== cliente.id));
        //         SetMensaje("Éxito", "Cliente eliminado correctamente.", 3000);
        //     } catch (error) {
        //         SetMensaje("Error", "Hubo un problema al eliminar el cliente.", 3000);
        //     }
        // }
    };

    if (!isVisible) return null;

    return (
        <div className="modal-overlay-cliente">
            <div className="modal-content-cliente">

                <div className="modal-header-cliente">
                    <div className="buscador-cliente-filtro">
                        <label>FILTRAR POR</label>
                        <select
                            className="select-filtro"
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                        >
                            <option>RAZON SOCIAL</option>
                            <option>CUIT</option>
                        </select>
                    </div>

                    <div className="buscador-cliente-input">
                        <input
                            ref={searchInputRef}
                            type="text"
                            placeholder={`Buscar por ${filterType}...`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                {/* TABLA DE clienteS */}
                <div className="tabla-cliente">
                    <div className="encabezado-tabla-cliente">
                        <div>RAZON SOCIAL</div>
                        <div>CUIT/CUIL</div>
                        <div>Acciones</div>
                    </div>

                    <div className="filas-cliente" ref={tablaRef}>
                        {filteredClientes.map((p, i) => (
                            <div
                                key={p.codigo}
                                className={`fila-cliente ${i === selectedIndex ? 'seleccionado' : ''}`}
                                onDoubleClick={() => handleSelect(p)}
                                onClick={() => setSelectedIndex(i)}
                            >
                                <div>{p.razon_social}</div>
                                <div>{formatCuit(p.cuit)}</div>
                                <div>
                                    {/* <button onClick={() => handleEdit(p)}>Editar</button> */}
                                    <button onClick={() => handleDelete(p)}>Eliminar</button>
                                </div>
                            </div>
                        ))}

                        {filteredClientes.length === 0 && (
                            <div className="fila-cliente-vacia">No se encontraron clientes.</div>
                        )}
                    </div>
                </div>

                <div className="modal-footer-cliente">
                    <div className="total-registros">
                        Total: {filteredClientes.length} registros disponibles
                    </div>

                    {/* Botón de Cancelar */}
                    <button className="boton-cancelar-cliente" onClick={onClose}>
                        ❌ Cancelar
                    </button>

                    {/* Botón de Ok */}
                    <button className="boton-ok-cliente" onClick={handleConfirm}>
                        ✅ Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BuscarClienteModal;